/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

// defines the styles used by the StatusIndicator
const useStyles = makeStyles((theme) => {
  return {
    container : {
      display     : 'flex',
      alignItems  : 'center',
      marginRight : 8
    },
    indicatorText : {
      fontSize      : 10,
      textTransform : 'uppercase',
      fontFamily    : theme?.typography?.fontFamily,
      fontWeight    : 700,
      lineHeight    : '12px',
      letterSpacing : '1px',
      marginRight   : 10,
      marginLeft    : 8
    },
    circle : {
      minWidth     : 8,
      minHeight    : 8,
      borderRadius : '50%'
    }
  };
});

export interface DeviceStatusType {
  text: string;
  color: string;
}

/**
 * @DeviceStatus
 *
 * ```typescript
 * 
 *  <DeviceStatus text={translate('basic:translation)} color={dlsColor('caRed')} />
 *
 * ```
 */
export const DeviceStatus = ({text, color}: DeviceStatusType) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.circle} style={{backgroundColor: color}} />
      {text && <span className={classes.indicatorText}>{text}</span>}
    </div>
  );
};

export default DeviceStatus;
